import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { decryptToken } from "../utils/getToken";

const UserDashboard = () => {
  const [userData, setUserData] = useState(null);
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    if (!isLoggedIn?.main_id) return;

    const fetchUserData = async () => {
      try {
        const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        setUserData(data?.users);
      } catch (error) {
        console.error("Failed to fetch user:", error);
      }
    };

    fetchUserData();
  }, [isLoggedIn?.main_id, url, token]);

  if (!userData)
    return <p className="text-gray-500 text-xs tracking-wide mb-5">Fetching your dashboard...</p>;

  return (
    <div className="">
      <h2 className="text-lg font-bold text-gray-900 tracking-tight">
        Hello,
        <span className="ml-1 bg-gradient-to-r from-blue-500 to-purple-600 text-transparent bg-clip-text">
          {userData.full_name}
        </span>
        ✨
      </h2>
    </div>
  );
};

export default UserDashboard;
